import React, {useEffect, useState} from 'react';
import API from '../../API';
import style from './text-creator.module.css'
import AddFile from "../questionCreator/components/AddFile";
import {useParams} from "react-router-dom";
import ContextMenu from "../questionCreator/components/ContextMenu";
import {ru} from "../../data/ru";
import {by} from "../../data/by";
function TextCreator() {
    let language = localStorage.getItem('lang') === 'ru' ?  ru.RoleIdThree: by.RoleIdThree;

    let { id } = useParams();

    const [text, setText] = useState('');
    const [title, setTitle] = useState('');
    const [context, setContext] = useState(<></>)

    let api = new API()
    useEffect(()=>{
        if(id){
            api.getText(id).then(data=>{
                setText(data.text)
                setTitle(data.title)
            })
        }
    },[])
    const handleTextChange = (event) => {
        setText(event.target.value);
    };

    const handleTitleChange = (event) => {
        setTitle(event.target.value)
    }

    const handleButtonClick = () => {
        let resultJSON = {
            'title': title,
            'text': text,
        };
        setTitle('')
        api.addText(resultJSON)
    };
    const handleButtonEditClick = () => {
        let resultJSON = {
            'title': title,
            'text': text,
        };
        setTitle('')
        api.editText(id,resultJSON).then(data=>{
            id =null;
            setText('')
            setTitle('')
        })
    };
    const close = () => {
        setContext(<></>)
    }
    const clickHandler = (e) => {
        e.preventDefault();
        setContext(<ContextMenu close={close}
                                changeText={handleTextChange}
                                element={e}
                                 />)
    }
    return (
        <div className={'test-creator-background'}>
            <div className={'test-creator-main'}>
                <div className={'test-creator-container'}>
                    <div className={style.main_content}>
                        <div className={style.box}>
                            <h1>{language.createTextConstructor}</h1>
                            <div className={style.boxLine}>
                                <h3>{language.createTestNameOfTheTest}:</h3>
                                <input className={style.text_input} type="text" value={title}
                                       onChange={handleTitleChange}/>
                            </div>
                            <div className={style.boxLine}>
                                <h3>{language.createTaskTypeText}:</h3>
                                <textarea style={{height: '400px'}} className={style.text_input} value={text}
                                          onChange={handleTextChange}
                                          onContextMenu={e => clickHandler(e)}/>
                            </div>
                            {context}
                            {!id? <button className={style.text_button} onClick={handleButtonClick} disabled={text.length===0 || title.length===0}>{language.createTextSendButton}</button>:
                                <button className={style.text_button} onClick={handleButtonEditClick} disabled={text.length===0 || title.length===0}>{language.updateTextSendButton}</button>}
                        </div>
                        <AddFile/>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default TextCreator;